import { createFileRoute } from "@tanstack/react-router"
import { ParticipantsPanel } from "@/features/live-events-admin/participants/ParticipantsPanel"

export const Route = createFileRoute("/live-events/$eventId/participants")({
	component: ParticipantsPage,
})

function ParticipantsPage() {
	const { eventId } = Route.useParams()
	return <ParticipantsPanel eventId={eventId} />
}
